import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss'],
})
export class NavbarComponent implements OnInit {
  @ViewChild('navbarCollapse') navbarCollapse!: ElementRef;
  @ViewChild('navbarToggleButton') navbarToggleButton!: ElementRef;

  constructor(private router: Router) {}

  ngOnInit(): void {
    this.router.events
    .pipe(filter((evt) => evt instanceof NavigationEnd))
    .subscribe(() => {
        this.navbarToggleButton.nativeElement.setAttribute('aria-expanded', 'false');
        
        if(this.navbarCollapse) {
          this.navbarCollapse.nativeElement.classList.remove('show');
        }
      });
  }
}
